/**
 * @description 登录IC用户体系的API
 */

import axios from 'axios'

const request = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? '/icApi' : process.env.VUE_APP_IC_URL,
  timeout: 6000,
})

// request 拦截器
request.interceptors.request.use(
  (config) => {
    config.headers['Content-Type'] = 'application/json'
    config.headers['Accept'] = 'application/json; charset=utf-8'
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

// response 拦截器
request.interceptors.response.use(
  (response) => {
    const code = response.status
    const res = response.data
    // 这里处理一些response 正常放回时的逻辑
    if (code < 200 || code > 300) {
      return Promise.reject(response)
    } else {
      return res
    }
  },
  (error) => {
    return Promise.reject(error)
  }
)

export function login(data) {
  return request({
    url: '/auth/weblogin',
    method: 'post',
    data,
  })
}

// 退出
export function logout() {
  return request({
    url: '/auth/loginout',
    method: 'post',
  })
}

export function findpass(mobile, vcode, newPwd) {
  return request({
    url: '/auth/findpass',
    method: 'post',
    data: {
      mobile,
      vcode,
      newPwd,
    },
  })
}

export function setpass(mobile, newPwd) {
  return request({
    url: '/auth/setpass',
    method: 'post',
    data: {
      mobile,
      newPwd,
    },
  })
}

export function modifypass(mobile, newPwd, oldPwd) {
  return request({
    url: '/auth/modifypass',
    method: 'post',
    data: {
      mobile,
      newPwd,
      oldPwd,
    },
  })
}

export function getInfo() {
  return request({
    url: '/auth/webinfo',
    method: 'get',
  })
}

export function getCodeImg() {
  return request({
    url: '/auth/vCode',
    method: 'get',
  })
}

export function sentSmsCode(mobile, type, uuid = '', imgCode = '') {
  return request({
    url: '/auth/mCode',
    method: 'post',
    data: {
      mobile,
      type,
      uuid,
      imgCode,
    },
  })
}

export function sentForgetSmsCode(mobile, type, uuid, imgCode) {
  return request({
    url: '/auth/mCode',
    method: 'post',
    data: {
      mobile,
      type,
      uuid,
      imgCode,
    },
  })
}

export function reg(username, password, code, uuid, registerSource) {
  return request({
    url: '/auth/reg',
    method: 'post',
    data: {
      username,
      password,
      code,
      uuid,
      registerSource,
    },
  })
}

export function regByywy(data) {
  return request({
    url: '/auth/regByywy',
    method: 'post',
    data,
  })
}

// 获取appid
export function sensitiveDetail() {
  return request({
    url: '/auth/sensitiveDetail',
    method: 'get',
  })
}

// 验证手机号是否绑定过并且返回unionid
export function wxloginByAuthorize(code) {
  return request({
    url: '/auth/wxloginByAuthorize',
    method: 'post',
    data: {
      code,
    },
  })
}

export function bindwx(username, code, unionid, openid) {
  return request({
    url: '/auth/bindwx',
    method: 'post',
    data: {
      username,
      openid,
      unionid,
      code,
    },
  })
}

// 解绑【原接口】
export function unWxBind(data) {
  return request({
    url: '/api/unWxBind',
    method: 'put',
    data,
  })
}

export function findOpenidByMobile(params) {
  return request({
    url: '/api/findOpenidByMobile',
    method: 'get',
    params,
  })
}

// php那边的解绑接口中转
export function wxUntying(params) {
  return request({
    url: '/api/tCustomer/wxUntying',
    method: 'get',
    params,
  })
}

// 验证当前手机号是否注册过ic
export function findtUserByMobile(params) {
  return request({
    url: '/api/findtUserByMobile',
    method: 'get',
    params,
  })
}
